import angular from 'angular';
import { IBancoHorasColaboradores } from '../models/bancohorascolaboradores.model';
import { LoadParams } from '../../../../shared/models/loadparams.model';

export class BancodeHorasService {
	static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

	public entity:  IBancoHorasColaboradores;
	public entities: Array<IBancoHorasColaboradores> = [];
	public loaded: boolean = false;
	public constructors: any = {};
	public after: any = {};
	public filters: any = {};
	public loadParams: LoadParams;
	public loading_deferred: any = null;
	public filter: any = '';

	constructor(
		public $http: angular.IHttpService,
		public nsjRouting: any,
		public $rootScope: angular.IRootScopeService,
		public $q: angular.IQService,
	) {
		this.loadParams = new LoadParams();
	}

	reload(): Array<IBancoHorasColaboradores> {
		if (this.loading_deferred) {
			this.loading_deferred.resolve();
		}

		this.loadParams.finished = false;
		this.loadParams.to_load = 3;
		this.after = {};
		this.loaded = false;
		this.entities.length = 0;
		this.loadParams.busy = false;

		return this.load();
	}

    search(filter: any = undefined): Array<any>  {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;
            Object.keys(this.filters).forEach((k: any) => { delete this.filters[k]; });
            for (var fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    var filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

	_load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'GET',
				url: this.nsjRouting.generate('ponto_historicosbancoapuracoes_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				resolve(response.data);
			})
			.catch((response: any) => {
				reject(response);
			});
		});
	}

	load(): Array<IBancoHorasColaboradores> {
		if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
			this.loadParams.busy = true;

			this._load(this.constructors, this.after, this.filter)
				.then((data: any): void => {
					if (data.length > 0) {
						for (var i = 0; i < data.length; i++) {
							this.entities.push(data[i]);
						}
					}

					this.loadParams.finished = true;
					this.loaded = true;
					this.loadParams.to_load = 0;
                    this.$rootScope.$broadcast('historicosbancoapuracoes_index_loaded', this.entities);
				})
				.catch((error: any): void => {
					if (error.xhrStatus !== 'abort') {
						this.loadParams.finished = true;
					}
				})
				.finally((): void => {
					if (this.loaded || this.loadParams.finished) {
						this.loadParams.busy = false;
					}

					this.load();
				});
		}

		return this.entities;
	}

	exportar(objetoExportacao: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'get',
				url: this.nsjRouting.generate('ponto_historicosbancoapuracoes_relatoriobancoshoras', angular.extend({}, this.constructors, {}), true),
				data: angular.copy(objetoExportacao),
				responseType: 'blob',
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('historicosbancoapuracoes_relatoriobancoshoras_sucesso', response);
				resolve(response.data);
			})
			.catch((response: any) => {
				this.$rootScope.$broadcast('historicosbancoapuracoes_relatoriobancoshoras_erro', response);
				reject(response);
			});
		});
	}

	exportarPDF(objetoExportacao: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_historicosbancoapuracoes_pdf', objetoExportacao, true),
				responseType: 'blob',
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('historicosbancoapuracoes_pdf_sucesso', response);
				resolve(response.data);
			})
			.catch((response: any) => {
				this.$rootScope.$broadcast('historicosbancoapuracoes_pdf_erro', response);
				reject(response);
			});
		});
	}
}
